<template>
  <div id="bd-cuw">
    <el-input
      size="mini"
      :placeholder="searchTip"
      suffix-icon="el-icon-search"
      v-model="filterCUW"
      clearable
    ></el-input>
    <el-tree
      class="filter-tree"
      :highlight-current="true"
      :data="allCuws"
      :props="defaultProps"
      default-expand-all
      :filter-node-method="filterCUWNode"
      @node-click="handleCUWNodeClick"
      ref="treeCUW"
    >
      <span class="custom-tree-node" slot-scope="{ node, data }">
        <el-tooltip
          v-if="node.isLeaf && node.level === 3"
          :content="tooltipPreview(data)"
          placement="top-start"
        >
          <span v-if="data.shortcut" style="font-size:14px;">{{ node.label.length > 15 ? node.label.substr(0, 15) + "[" + data.shortcut + "]" : node.label + "[" + data.shortcut + "]" }}</span>
          <span v-if="!data.shortcut" style="font-size:14px;">{{ node.label.length > 15 ? node.label.substr(0, 15) + "..." : node.label }}</span>
        </el-tooltip>
        <span style="font-size:14px;" v-if="node.isLeaf && node.level != 3">{{
          node.label.length > 15 ? node.label.substr(0, 15) + "..." : node.label
        }}</span>
        <span style="font-size:14px;" v-if="!node.isLeaf">{{
          node.label.length > 15 ? node.label.substr(0, 15) + "..." : node.label
        }}</span>
        <span v-if="node.isLeaf && node.level === 3">
          <!-- 图片单独处理 -->
          <el-popover
            v-if="data.type === 'image'"
            trigger="click"
            placement="top"
            height="450"
            width="450"
          >
            <el-image
              :src="data.content"
              :preview-src-list="[data.content]"
              style="width: 450px; height: 450px;"
            />
            <el-button
              slot="reference"
              size="mini"
              type="text"
              style="margin-right: 10px;"
              >{{ $t("view") }}</el-button
            >
          </el-popover>
          <!-- 图片上面单独处理 -->
          <el-button
            v-if="
              data.type !== null &&
                data.type !== 'text' &&
                data.type !== 'image' &&
                data.type !== 'card' &&
                data.type !== 'choice'
            "
            size="mini"
            type="text"
            style="margin-left: 5px;"
            @click="viewNodeCuw(data)"
            >{{ $t("view") }}</el-button
          >
          <el-button size="mini" type="text" @click="sendNodeCuw(data)">{{
            $t("send")
          }}</el-button>
          <el-button size="mini" type="text" @click="copyNodeCuw(data)">{{
            $t("copy")
          }}</el-button>
          <el-button
            v-if="node.parent.parent.data.id === 0"
            size="mini"
            type="text"
            @click="editNodeCuw(node, data)"
            >{{ $t("edit") }}</el-button
          >
          <el-button
            v-if="node.parent.parent.data.id === 0"
            size="mini"
            type="text"
            @click="deleteNodeCuw(node, data)"
            >{{ $t("delete") }}</el-button
          >
          <!-- FIXME: 全部显示 -->
          <!-- <el-popover
            placement="top"
            width="160"
            v-model="deletePopVisible">
            <p>确定删除?</p>
            <div style="text-align: right; margin: 0">
              <el-button size="mini" type="text" @click="() => { deletePopVisible = false }">取消</el-button>
              <el-button size="mini" type="primary" @click="() => this.deleteNodeCuw(node, data)">确定</el-button>
            </div>
            <el-button size="mini" type="text" slot="reference" style="margin-left: 5px;">删除</el-button>
          </el-popover> -->
        </span>
      </span>
    </el-tree>
    <!-- :render-content="renderContent" -->
    <div style="margin-top: 15px; float: left;">
      <el-dropdown style="margin-right: 5px; float: left;">
        <el-button type="success" size="mini">
          {{ $t("add") }}<i class="el-icon-arrow-down el-icon--right"></i>
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item @click.native="addCategory">{{
            $t("category")
          }}</el-dropdown-item>
          <el-dropdown-item @click.native="addCUW">{{
            $t("cuw")
          }}</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <el-button
        @click="editCUW()"
        type="primary"
        size="mini"
        style="margin-right: -5px; float: left;"
        :disabled="editButtonDisabled"
        >{{ $t("edit") }}</el-button
      >
      <el-button
        @click="deleteCUW()"
        type="danger"
        size="mini"
        style="float: left;"
        :disabled="deleteButtonDisabled"
        >{{ $t("delete") }}</el-button
      >
    </div>
    <el-dialog
      v-dialogDrag
      :title="addCuwTip"
      :visible.sync="addCuwDialogVisible"
      width="60%"
      center
    >
      <el-form ref="form" :model="form" :rules="rules" label-width="80px">
        <el-form-item :label="titleTip" prop="name">
          <el-input v-model="form.name" :placeholder="titleTip"></el-input>
          <span>{{ $t("easyToRemember") }}</span>
        </el-form-item>
        <el-form-item v-if="showSwitchType" :label="typeTip">
          <el-radio-group v-model="form.type">
            <el-radio key="text" label="text">{{ $t("text") }}</el-radio>
            <el-radio key="image" label="image">{{ $t("image2") }}</el-radio>
            <el-radio key="file" label="file">{{ $t("file") }}</el-radio>
            <el-radio key="voice" label="voice">{{ $t("voice") }}</el-radio>
            <el-radio key="video" label="video">{{ $t("video2") }}</el-radio>
            <el-radio key="card" label="card">{{ $t("card") }}</el-radio>
            <el-radio key="choice" label="choice" v-if="!isProduction">{{ $t("choice") }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- 富文本 -->
        <el-form-item v-if="showInput" label="富文本">
          <el-radio-group v-model="form.richtext">
            <el-radio :key="true" :label="true">是</el-radio>
            <el-radio :key="false" :label="false">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="showInput" :label="contentTip" prop="content">
          <el-input v-if="!form.richtext" type="textarea"
            :autosize="{ minRows: 2, maxRows: 5 }"
            v-model="form.content"></el-input>
          <tinymce v-if="form.richtext" v-model="form.content"></tinymce>
          <span>{{ $t("realSendContent") }}</span>
        </el-form-item>
        <!-- 选择 -->
        <el-form-item v-if="showChoice" label="问题">
          <el-input placeholder="问题" v-model="form.content" :autosize="{ minRows: 2, maxRows: 5 }"/>
          <el-button size="small" @click="addChoice">增加选项</el-button>
          <p style="color: gray;">添加选项</p>
        </el-form-item>
        <el-form-item v-for="(choice, index) in form.choices" :label="'选项' + index" :key="index">
          <el-input v-model="form.choices[index]"></el-input>
          <el-button @click="removeChoice(choice)">删除</el-button>
        </el-form-item>
        <!-- 上传 -->
        <el-form-item v-if="showUpload" :label="uploadTip">
          <p></p>
          <el-input
            :placeholder="pleaseInputAutoReplyImageTip"
            v-model="form.content"
          ></el-input>
          <p></p>
          <el-image
            v-if="showImage"
            :src="form.content"
            :preview-src-list="[form.content]"
            style="float: left; margin-right: 15px; width: 40px; height: 40px;"
          />
          <i v-if="showImage" @click="removeImage" class="el-icon-close"></i>
          <p></p>
          <el-upload
            class="upload-demo"
            :data="upload_data"
            :name="upload_name"
            :action="uploadImageServerUrl"
            :on-success="handleImageUploadSuccess"
            :before-upload="beforeImageUpload"
          >
            <el-button size="small" type="primary">{{ uploadTip }}</el-button>
          </el-upload>
          <span>{{ $t("realSendContent") }}</span>
        </el-form-item>
        <el-form-item :label="belongGroupTip" prop="categoryId" v-if="!isEdit">
          <span v-if="allCuws[0].cuwChildren.length === 0">{{
            $t("pleaseCreateAtLeaseOneGroupFirst")
          }}</span>
          <el-radio-group v-model="form.categoryId">
            <el-radio
              v-for="category in allCuws[0].cuwChildren"
              :key="category.id"
              :label="category.id"
              >{{ category.name }}</el-radio
            >
          </el-radio-group>
        </el-form-item>
        <el-form-item :label="shortcutTip" prop="shortcut">
          <el-input v-model="form.shortcut" :placeholder="shortcutTip" @blur="handleShortcutBlur" @focus="handleShortcutFocus"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="addCuwDialogVisible = false">{{ $t("cancel") }}</el-button>
        <el-button size="small" type="primary" @click="doAddCuw()">{{ $t("ok") }}</el-button>
      </span>
    </el-dialog>
    <!-- <el-backtop target=".el-tree .filter-tree .el-tree--highlight-current"></el-backtop> -->
  </div>
</template>

<script>
import moment from "moment";
import { mapActions, mapGetters } from "vuex";
import * as constants from "@/util/constants";
import bus from "@/util/eventbus";

export default {
  name: "bd-cuw",
  data() {
    return {
      isProduction: constants.IS_PRODUCTION,
      isEdit: false,
      addCuwDialogVisible: false,
      electron: constants.IS_ELECTRON,
      currentSelectedNote: {
        id: 0,
        name: "",
        content: "",
        choices: [],
        type: "",
        richtext: false,
        published: true,
        shortcut: "",
        categoryId: 0,
        cuwChildren: [],
      },
      showSwitchType: true,
      form: {
        id: 0,
        name: "",
        type: "text",
        content: "",
        choices: [],
        richtext: false,
        published: true,
        shortcut: "",
        categoryId: "",
        cuwChildren: [],
      },
      rules: {
        name: [{ required: true, message: "请输入标题", trigger: "blur" }],
        // content: [
        //   { required: true, message: '请输入内容', trigger: 'blur' }
        // ],
        categoryId: [
          { required: true, message: "请至少选择一个分组", trigger: "change" },
        ],
      },
      emptyText: "暂无数据",
      filterCUW: "",
      defaultProps: {
        children: "cuwChildren",
        label: "name",
      },
      deletePopVisible: false,
      // 上传图片相关参数
      upload_headers: {
        "X-CSRF-TOKEN": "",
        "X-Requested-With": "XMLHttpRequest",
        Accept: "application/json",
        Authorization: "Bearer ",
      },
      upload_data: {
        file_name: "test.png",
        username: "",
        type: "",
        client: "web"
      },
      upload_name: "file",
      uploadImageServerUrl: constants.UPLOAD_FILE_URL_V3, // constants.UPLOAD_IMAGE_URL,
      //
      isShortcutInputFocus: false,
      shortcurKeydown: '',
      triggerFlag:false,
      shortcurKeys:[],
      forbidShortcut: false // 当设置为true的时候，禁用此快捷键
    };
  },
  computed: {
    ...mapGetters(["allCuws"]),
    searchTip() {
      return this.$t("search");
    },
    addCuwTip() {
      return this.$t("addCuw");
    },
    titleTip() {
      return this.$t("title");
    },
    typeTip() {
      return this.$t("type");
    },
    contentTip() {
      return this.$t("content");
    },
    belongGroupTip() {
      return this.$t("belongGroup");
    },
    uploadTip() {
      return this.$t("upload");
    },
    shortcutTip() {
      return this.$t("shortcut")
    },
    choiceTip() {
      return this.$t("choice")
    },
    pleaseInputAutoReplyImageTip() {
      return this.$t("pleaseInputAutoReplyImage");
    },
    editButtonDisabled() {
      for (let i = 0; i < this.allCuws[0].cuwChildren.length; i++) {
        const category = this.allCuws[0].cuwChildren[i];
        if (category.id === this.currentSelectedNote.id) {
          return false;
        }
        for (let j = 0; j < category.cuwChildren.length; j++) {
          const cuw = category.cuwChildren[j];
          if (cuw.id === this.currentSelectedNote.id) {
            return false;
          }
        }
      }
      return true;
    },
    deleteButtonDisabled() {
      for (let i = 0; i < this.allCuws[0].cuwChildren.length; i++) {
        const category = this.allCuws[0].cuwChildren[i];
        if (category.id === this.currentSelectedNote.id) {
          if (category.cuwChildren.length > 0) {
            return true;
          }
          return false;
        }
        for (let j = 0; j < category.cuwChildren.length; j++) {
          const cuw = category.cuwChildren[j];
          if (cuw.id === this.currentSelectedNote.id) {
            return false;
          }
        }
      }
      return true;
    },
    showImage() {
      return (
        this.form.type === "image" &&
        this.form.content != "" &&
        this.form.content != null &&
        this.form.content != undefined
      );
    },
    showInput() {
      if (this.form.type === 'text') {
        return true
      }
      return false
    },
    showChoice() {
      if (this.form.type === 'choice') {
        return true
      }
      return false
    },
    showUpload() {
      if (this.form.type === 'image' || this.form.type === 'file' || this.form.type === 'voice' || this.form.type === 'video' || this.form.type === 'card') {
        return true
      }
      return false
    },
  },
  watch: {
    filterCUW(val) {
      this.$refs.treeCUW.filter(val);
    },
  },
  methods: {
    ...mapActions("mqtt", ["sendMessageProtobuf"]),
    ...mapActions([
      "userCurrentThread",
      "createCategory",
      "updateCategory",
      "deleteCategory",
      "cuwCreate",
      "cuwUpdate",
      "cuwDelete",
    ]),
    tooltipPreview(data) {
      if (data.type === 'choice') {
        let choice = '['
        for (let i = 0; i < data.choices.length; i++) {
          const element = data.choices[i]
          choice += element
          if (i + 1 < data.choices.length) {
            choice += ','
          }
        }
        choice += ']'
        return data.content + choice
      }
      return data.content
    },
    addChoice() {
      if (this.form.choices.length < 5) {
        this.form.choices.push('')
      } else {
        this.$message.error('不能超过5条')
      }
    },
    removeChoice(choice) {
      console.log('remove:', choice)
      for (let i = 0; i < this.form.choices.length; i++) {
        const element = this.form.choices[i]
        if (element === choice) {
          this.form.choices.splice(i, 1)
        }
      }
    },
    removeImage() {
      this.form.content = "";
    },
    handleImageUploadSuccess(result, file) {
      // console.log('upload success result:', result, ' file:', file)
      if (result.status_code === 200) {
        this.form.content = result.data;
      } else {
        this.$message.error("上传错误，请稍后重试...");
      }
    },
    beforeImageUpload(file) {
      // 设置文件名
      // let filename = moment(new Date()).format("YYYYMMDDHHmmss");
      // if (file.type === "image/jpeg") {
      //   this.upload_data.file_name = filename + ".jpg";
      // } else if (file.type === "image/png") {
      //   this.upload_data.file_name = filename + ".png";
      // }
      let timestamp = moment(new Date()).format("YYYYMMDDHHmmss");
      this.upload_data.file_name = timestamp + file.name;
      this.upload_data.username = this.userInfo.username
      this.upload_data.type = constants.UPLOAD_FILE_TYPE_FILE
      return true;
    },
    filterCUWNode(value, data) {
      // console.log(data)
      if (!value) return true;
      if (data.type === "text") {
        return (
          data.name.indexOf(value) !== -1 || data.content.indexOf(value) !== -1
        );
      }
      return data.name.indexOf(value) !== -1;
    },
    handleCUWNodeClick(data, node) {
      // console.log('handleCUWNodeClick:', data, node)
      if (data.id === 0 || data.id === -1 || data.id === -2) {
        this.currentSelectedNote.id = 0;
        return;
      }
      //
      this.currentSelectedNote.id = data.id;
      this.currentSelectedNote.name = data.name;
      this.currentSelectedNote.richtext = data.richtext
      this.currentSelectedNote.shortcut = data.shortcut
      this.currentSelectedNote.choices = data.choices
      if (data.type) {
        this.currentSelectedNote.type = data.type;
      } else {
        this.currentSelectedNote.type = constants.MESSAGE_TYPE_TEXT;
      }
      this.currentSelectedNote.cuwChildren = [];
      //
      if (data.type === constants.CATEGORY_TYPE_CUW_MINE) {
        this.currentSelectedNote.cuwChildren = data.cuwChildren;
      } else {
        // 快捷回复
        // FIXME: 直接在编辑对话框修改分组
        // this.currentSelectedNote.categoryId = data.category.id
        this.currentSelectedNote.content = data.content;
      }
      // 事件总线广播事件
      if (data.content !== null && data.content !== undefined) {
        bus.$emit(constants.EVENT_BUS_SELECT_CUW, data.content);
      }
    },
    // 分类
    addCategory() {
      this.$prompt(this.$t("inputCategoryName"), this.$t("tip"), {
        confirmButtonText: this.$t("ok"),
        cancelButtonText: this.$t("cancel"),
      })
        .then(({ value }) => {
          // console.log(value)
          if (value !== undefined && value !== null && value.length > 0) {
            let payload = {
              parent_id: 0,
              name: value,
              type: constants.CATEGORY_TYPE_CUW_MINE,
            };
            this.createCategory(payload);
          }
        })
        .catch(() => {
          // 取消
        });
    },
    addCUW() {
      if (this.allCuws[0].cuwChildren.length === 0) {
        this.$message({
          message: this.$t("pleaseCreateAtLeaseOneGroupFirst"),
          type: "warning",
        });
        return;
      }
      this.isEdit = false;
      this.showSwitchType = true;
      this.addCuwDialogVisible = true;
      //
      this.form = {
        id: 0,
        name: "",
        type: "text",
        content: "",
        choices: [],
        richtext: false,
        published: true,
        shortcut: "",
        categoryId: "",
        cuwChildren: [],
      };
    },
    doAddCuw() {
      if (this.form.content.length > 256) {
        this.$message({
          message: this.$t("contentTooLong"),
          type: "warning",
        });
        return
      }
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.addCuwDialogVisible = false;
          if (this.isEdit) {
            let payload = {
              id: this.form.id,
              name: this.form.name,
              content: this.form.content,
              choices: this.form.choices,
              type: this.form.type,
              richtext: this.form.richtext,
              published: this.form.published,
              shortcut: this.form.shortcut,
            };
            this.cuwUpdate(payload);
            this.currentSelectedNote.id = 0;
          } else {
            let payload = {
              categoryId: this.form.categoryId,
              name: this.form.name,
              content: this.form.content,
              choices: this.form.choices,
              type: this.form.type,
              richtext: this.form.richtext,
              published: this.form.published,
              shortcut: this.form.shortcut,
            };
            this.cuwCreate(payload);
          }
        } else {
          return false;
        }
      });
    },
    editCUW() {
      // console.log('currentSelectedNote:', this.currentSelectedNote)
      this.isEdit = true;
      this.showSwitchType = false;
      //
      this.form.id = this.currentSelectedNote.id;
      this.form.name = this.currentSelectedNote.name;
      this.form.type = this.currentSelectedNote.type;
      this.form.richtext = this.currentSelectedNote.richtext;
      this.form.shortcut = this.currentSelectedNote.shortcut;
      this.form.choices = this.currentSelectedNote.choices
      if (this.currentSelectedNote.type === constants.CATEGORY_TYPE_CUW_MINE) {
        // 分组
        this.$prompt(this.$t("editCategoryName"), this.$t("tip"), {
          confirmButtonText: this.$t("ok"),
          cancelButtonText: this.$t("cancel"),
          inputValue: this.form.name,
        })
          .then(({ value }) => {
            // console.log(value)
            if (value !== undefined && value !== null && value.length > 0) {
              let payload = { category_id: this.form.id, name: value };
              this.updateCategory(payload);
              this.currentSelectedNote.id = 0;
            }
          })
          .catch(() => {
            // 取消
          });
      } else {
        // 快捷回复
        this.form.categoryId = this.currentSelectedNote.categoryId;
        this.form.content = this.currentSelectedNote.content;
        this.addCuwDialogVisible = true;
      }
    },
    deleteCUW() {
      console.log('currentSelectedNote:', this.currentSelectedNote)
      if (
        this.currentSelectedNote.cuwChildren != null &&
        this.currentSelectedNote.cuwChildren != undefined &&
        this.currentSelectedNote.cuwChildren.length > 0
      ) {
        this.$message({
          message: this.$t("deleteChildCuwFirst"),
          type: "warning",
        });
        return;
      }
      this.$confirm(this.$t("deleteASure"), this.$t("tip"), {
        confirmButtonText: this.$t("ok"),
        cancelButtonText: this.$t("cancel"),
        type: "warning",
      }).then(() => {
        if (this.currentSelectedNote.type === constants.CATEGORY_TYPE_CUW_MINE) {
          // 分组
          this.deleteCategory(this.currentSelectedNote.id);
        } else {
          // 快捷回复
          this.cuwDelete(this.currentSelectedNote.id);
        }
        this.currentSelectedNote.id = 0;
      })
      .catch(() => {});
    },
    viewNodeCuw(data) {
      // console.log('view:', data)
      if (this.electron) {
        ipcRenderer.send("open-external-url", data.content);
      } else {
        window.open(data.content);
      }
    },
    sendNodeCuw(data) {
      // console.log('send:', data)
      // 事件总线广播事件
      bus.$emit(constants.EVENT_BUS_SEND_CUW, data);
    },
    copyNodeCuw(data) {
      // console.log('copy:', data)
      this.copyToClip(data.content);
      this.$message('"' + data.content + '" ' + this.$t("copiedToClip"));
    },
    editNodeCuw(node, data) {
      // console.log('edit:', data)
      this.handleCUWNodeClick(data, node);
      this.editCUW();
    },
    deleteNodeCuw(node, data) {
      // console.log('delete:', node, data)
      this.handleCUWNodeClick(data, node);
      this.deleteCUW();
    },
    copyToClip(content) {
      var aux = document.createElement("input");
      aux.setAttribute("value", content);
      document.body.appendChild(aux);
      aux.select();
      document.execCommand("copy");
      document.body.removeChild(aux);
    },
    handleShortcutFocus() {
      // console.log('handleShortcutFocus')
      this.isShortcutInputFocus = true
    },
    handleShortcutBlur() {
      // console.log('handleShortcutBlur')
      this.isShortcutInputFocus = false
    },
    // TODO: 快捷键绑定，发送常用语
    handleKeyDown(e) {
      // control、alt（mac：option）、shift、meta（mac：command）
      // console.log('handleKeyDown:', e.key.toLowerCase())
      let that = this
      if (that.shortcurKeys.length > 0) {
        // a-z的按键 长按去重
        if (that.shortcurKeys.indexOf(e.key.toLowerCase()) >= 0) {
          return
        }
      }
      that.shortcurKeys.push(e.key.toLowerCase())
      this.shortcurKeydown = that.shortcurKeys.join('+')
      // console.log('handleKeyDown:', this.shortcurKeydown)
      if (this.addCuwDialogVisible) {
        if (!this.isShortcutInputFocus) {
          // 快捷键输入框 未 获取输入焦点
          return
        }
        // console.log("开启设置快捷键设置模式")
        if (e.key.toLowerCase() === 'backspace') {
          // 按删除键，清空快捷键
          this.form.shortcut = ''
        } else {
          // 判断是否已经存在此快捷键
          let contains = false
          for (let k = 0; k < 2; k++) {
            for (let i = 0; i < this.allCuws[k].cuwChildren.length; i++) {
              const category = this.allCuws[k].cuwChildren[i];
              for (let j = 0; j < category.cuwChildren.length; j++) {
                const cuw = category.cuwChildren[j];
                // 区分大小写
                if (cuw.shortcut === this.shortcurKeydown) {
                  console.log('已经存在此快捷键：', cuw.content, cuw.shortcut)
                  contains = true
                  this.$message({
                    message: '已经存在此快捷键，请重新定义',
                    type: 'warning'
                  });
                }
              }
            }
          }
          if (!contains) {
            // 设置快捷键
            this.form.shortcut = this.shortcurKeydown
          }
        }
      } else {
        // console.log("快捷键触发模式")
        // 仅对比 自定义常用语 和 公司常用语，平台常用语未定义快捷键无需处理
        for (let k = 0; k < 2; k++) {
          for (let i = 0; i < this.allCuws[k].cuwChildren.length; i++) {
            const category = this.allCuws[k].cuwChildren[i];
            for (let j = 0; j < category.cuwChildren.length; j++) {
              const cuw = category.cuwChildren[j];
              // 区分大小写
              if (cuw.shortcut === this.shortcurKeydown) {
                // console.log('发送常用语：', cuw.content, cuw.shortcut)
                bus.$emit(constants.EVENT_BUS_SEND_CUW, cuw);
              }
            }
          }
        }

        // TODO: 处理浏览器默认操作
        // if (this.shortcurKeydown == 'shift+s') {
        //   if (that.forbidShortcut) {
        //     e.preventDefault()
        //     return
        //   }
        //   this.shortcurKeydown = ''
        //   // TODO: 在这里面写你要用快捷键做的事情

        //   e.preventDefault()// 取消浏览器原有的操作
        // }
      }
    },
    handleKeyUp(e) {
      // console.log('handleKeyUp:', e.key.toLowerCase())
      this.shortcurKeys.splice(this.shortcurKeys.indexOf(e.key.toLowerCase()), 1)
      this.shortcurKeydown = this.shortcurKeys.join('+')
      // console.log('handleKeyUp:', this.shortcurKeydown)
      e.preventDefault()
    },
  },
  created() {
    document.addEventListener('keydown', this.handleKeyDown)
    document.addEventListener('keyup', this.handleKeyUp)
  },
  mounted() {
    // 点击消息添加到快捷回复
    let app = this;
    bus.$on(constants.EVENT_BUS_ADD_MESSAGE_TO_CUW, (message) => {
      // console.log("type:" + message.type);
      app.isEdit = false;
      app.showSwitchType = true;
      app.form.type = message.type;
      app.form.richtext = false
      if (message.type === constants.MESSAGE_TYPE_TEXT) {
        app.form.name = message.content;
        app.form.content = message.content;
      } else if (message.type === constants.MESSAGE_TYPE_IMAGE) {
        app.form.content = message.imageUrl;
      } else if (message.type === constants.MESSAGE_TYPE_FILE) {
        app.form.content = message.fileUrl;
      } else if (message.type === constants.MESSAGE_TYPE_VOICE) {
        app.form.content = message.voiceUrl;
      } else if (message.type === constants.MESSAGE_TYPE_VIDEO) {
        app.form.content = message.videoOrShortUrl;
      } else {
        app.form.type = constants.MESSAGE_TYPE_TEXT;
        app.form.name = message.content;
        app.form.content = message.content;
      }
      app.addCuwDialogVisible = true;
    });
  },
  destroyed() {
    document.removeEventListener('keydown', this.handleKeyDown)
    document.removeEventListener('keyup', this.handleKeyUp)
  }
};
</script>

<style scoped>
#bd-cuw {
  height: 100%;
  width: 100%;
}
.filter-tree {
  margin-top: 10px;
  margin-bottom: 10px;
  height: 100%;
  overflow-y: scroll !important;
}
.el-form {
  margin-bottom: 0px;
}
/* .el-tree-node__label {
  font-size: 12px !important;
} */
.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}
</style>
